module.exports = __webpack_public_path__ + "img/terms.a27a4f40.svg";